// @flow
import firestore from '../services/firestore';
import zoneSchema from '../../server/shared/schemas/zone';

export default zoneSchema(firestore);